import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import FeaturedProject from "@/components/FeaturedProject";
import WhyChooseUs from "@/components/WhyChooseUs";

import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection, { faqs } from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const Index = () => {
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Villalobos Prime Services LLC",
    image: "https://villalobosprimeservicesllc.com/images/logo.png",
    telephone: "+1-786-306-5704",
    url: "https://villalobosprimeservicesllc.com/",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Deltona",
      addressRegion: "FL",
      addressCountry: "US",
    },
    areaServed: "Central Florida",
  };
  const faqPage = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Villalobos Prime Services LLC | Painting & Remodeling in Deltona, FL"
        description="Interior & exterior painting, tile & vinyl flooring, bathroom remodeling, drywall, and cabinet work in Deltona, FL and Central Florida. Free estimates — (786) 306-5704."
        path="/"
        jsonLd={[localBusiness, faqPage]}
      />
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProject />
        <ServicesSection />
        <WhyChooseUs />
        
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;